/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ExportD1PortfolioDashboardsD1PortfolioExcelGet$Params {
  /**
   * Фильтр по отрасли
   */
  industry_id?: number | null;

  /**
   * Фильтр по категории
   */
  category?: string | null;

  /**
   * Фильтр по региону
   */
  region_id?: number | null;

  /**
   * Сортировка: npv_desc (по умолчанию), npv_asc, name_asc
   */
  sort?: 'npv_desc' | 'npv_asc' | 'name_asc';
}

export function exportD1PortfolioDashboardsD1PortfolioExcelGet(
  http: HttpClient,
  rootUrl: string,
  params?: ExportD1PortfolioDashboardsD1PortfolioExcelGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, exportD1PortfolioDashboardsD1PortfolioExcelGet.PATH, 'get');
  if (params) {
    rb.query('industry_id', params.industry_id, {});
    rb.query('category', params.category, {});
    rb.query('region_id', params.region_id, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<any>;
    }),
  );
}

exportD1PortfolioDashboardsD1PortfolioExcelGet.PATH = '/dashboards/d1/portfolio/excel';
